<template>
  <div id="index" class="detail">
    <h4 class="title">
      {{msgTitle}}
    </h4>
    <span class="time">{{msgPushtime}}</span>

    <div class="info">
      <p>
         <div  v-html="msgContent"></div> 
      </p>
    </div>
  </div>
</template>
<style lang='less' scope>
.detail{
  padding:3px;
   font-family:  Arial, 'Microsoft YaHei';
   width:100%;
  
   img{
    width:99%;
   }
}

span.time{
  font-size: 12px;
  font-family:  Arial, 'Microsoft YaHei';
  color:#777;
}
h4.title{
  margin:0;
  margin-bottom: 10px;
  font-family:  Arial, 'Microsoft YaHei';
}
img{
  max-width:99%;
}
table {
    border-spacing: 0;
    border-collapse: collapse;
}
 
</style>

<script>
import { mapState } from "vuex";
import {getMessageById} from '../../api/api'
export default {
  name: "index",
  data() {
    return {
      msgTitle:"",
      msgContent:"",
      msgPushtime:"",
      formselect: {
        Id:""
      },
    };
  },
  mounted() {
    debugger
    if (this.$route.query.id) {
      this.formselect.msgId = this.$route.query.id;
    }else if(this.$route.query.Id){
      this.formselect.msgId = this.$route.query.Id;
    }
    this.getData();
  },
  methods: {
    getData() {
      var data = this.formselect
      data.Id = this.formselect.msgId 

      getMessageById(data).then(res => {
        if (res.success) {
          this.msgTitle = res.result.title
          this.msgContent = res.result.content
          this.msgPushtime = res.result.pushTime
        }
      })
     
    },
  },
};
</script>

 
